import { useSuspenseQuery } from '@tanstack/react-query';

import { ConfigApiInstance } from '~src/main/api';

function localeCompareName<T extends { name?: string }>(a: T, b: T): number {
  return a.name!.localeCompare(b.name!);
}

export function useMerchantQueryKey() {
  const keys = {
    all: ['merchants'] as const,
    lists: () => [...keys.all, 'list'] as const,
  };

  return keys;
}

export function useDetailedMerchantListQuery() {
  const queryKey = useMerchantQueryKey();

  const {
    data: { merchants = [] },
  } = useSuspenseQuery({
    queryFn: async () => {
      const { data } = await ConfigApiInstance.merchantsList.configListMerchants();
      return data;
    },
    queryKey: queryKey.lists(),
  });

  return {
    merchants: merchants
      .filter(merchant => merchant.sites?.length ?? 0 > 0)
      .sort(localeCompareName)
      .map(merchant => ({
        sites: (merchant.sites ?? []).filter(s => !s.is_draft).sort(localeCompareName),
        name: merchant.name,
        id: merchant.id,
      })),
  };
}
